<template>
  <div class="enjoy-img" v-if="list.length>0">
    <div class="title">
      <img
        class="pc-title"
        src="https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-title4.png"
        alt
      />
      <img
        class="m-title"
        src="https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-title4.png"
        alt
      />
    </div>
    <div class="box">
      <div class="swiper-wrap">
        <!-- swiper1 -->
        <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
          <swiper-slide :key="index" v-for="(item ,index) in list">
            <img class="item" :src="item.img" alt="轮播" />
          </swiper-slide>
        </swiper>
        <!-- swiper2 Thumbs -->
        <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
          <swiper-slide :key="index" v-for="(item ,index) in list">
            <img class="item" :src="item.img" alt="轮播" />
          </swiper-slide>
        </swiper>
        <div id="enjoy-img-prev" slot="button-prev"></div>
        <div id="enjoy-img-next" slot="button-next"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import XHR from '../api'

import 'swiper/dist/css/swiper.css'
export default {
  name: 'EnjoyImg',
  props: [],
  data: () => ({
    list: []

  }),
  components: {
    swiper,
    swiperSlide
  },
  created () {
    const width = document.body.clientWidth
    if (width <= 750) {
      this.swiperOptionTop = {
        loop: true,
        spaceBetween: 13,
        loopedSlides: 4,
        navigation: {
          nextEl: '#enjoy-img-next',
          prevEl: '#enjoy-img-prev'
        }
      }
      this.swiperOptionThumbs = {
        loop: true,
        spaceBetween: 13,
        centeredSlides: false,
        slidesPerView: 4,
        touchRatio: 0.2,
        loopedSlides: 4,
        slideToClickedSlide: true
      }
    } else {
      this.swiperOptionTop = {
        loop: true,
        spaceBetween: 10,
        loopedSlides: 5,
        navigation: {
          nextEl: '#enjoy-img-next',
          prevEl: '#enjoy-img-prev'
        }
      }
      this.swiperOptionThumbs = {
        loop: true,
        spaceBetween: 10,
        // centeredSlides: true,
        slidesPerView: 5,
        touchRatio: 0.2,
        loopedSlides: 5,
        slideToClickedSlide: true
      }
    }
  },
  mounted () {
    this.getEnjoyImg()
  },
  methods: {
    getEnjoyImg () {
      XHR.getEnjoyImg().then((res) => {
        const { status, data } = res.data
        if (status === 0) {
          this.list = data
          this.$nextTick(() => {
            const swiperTop = this.$refs.swiperTop.swiper
            const swiperThumbs = this.$refs.swiperThumbs.swiper
            swiperTop.controller.control = swiperThumbs
            swiperThumbs.controller.control = swiperTop
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.enjoy-img {
  margin-top: 78px;
}
.title {
  .pc-title {
    display: none;
  }
  .m-title {
    margin: 0 auto;
    display: block;
    width: 300px;
  }
}
.box {
  position: relative;
  margin: 0 auto;
  background-size: cover;
  background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-box4.png");
  width: 690px;
  height: 620px;
  padding: 3px;
  box-sizing: border-box;
  .swiper-wrap {
    position: absolute;
    bottom: 3px;
    left: 3px;
    right: 3px;
    top: 3px;
    box-sizing: border-box;
    padding: 43px 20px 20px;
    border-radius: 40px;
    .gallery-top {
      border: 4px solid #f5cd94;
      height: 419px;
      width: 630px;
    }
    .gallery-thumbs {
      box-sizing: border-box;
      margin: 0 50px;
      .swiper-slide {
        margin-top: 20px;
        box-sizing: border-box;
        height: 86px;
        width: 147px;
        border: 3px solid #af0404;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          background-color: rgba(0, 0, 0, 0.6);
          color: #fff;
          text-align: center;
        }
      }
      .swiper-slide-active {
        opacity: 1;
        border: 3px solid #f5cd94;
        &::before {
          content: "";
          width: 0;
          height: 0;
          position: absolute;
          top: -10px;
          left: calc(50% - 7px);
          border-right: solid 10px transparent;
          border-left: solid 10px transparent;
          border-bottom: solid 10px #f5cd94;
        }
        &::after {
          content: none;
        }
      }
    }
    #enjoy-img-prev {
      position: absolute;
      left: 23px;
      bottom: 36px;
      cursor: pointer;
      margin-top: 20px;
      background-size: cover;
      background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-btn.png");
      width: 35px;
      height: 88px;
      z-index: 100;
      transform: rotateY(180deg);
      outline: none;
      &.swiper-button-disabled {
        position: absolute;
        right: 0;
        top: 0;
        background-size: cover;
        background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-disable.png");
        transform: rotateY(0);
        width: 40px;
        height: 100px;
        z-index: 100;
      }
    }
    #enjoy-img-next {
      position: absolute;
      right: 23px;
      bottom: 36px;
      cursor: pointer;
      margin-top: 20px;
      background-size: cover;
      background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-btn.png");
      width: 35px;
      height: 88px;
      z-index: 100;
      outline: none;
      &.swiper-button-disabled {
        position: absolute;
        right: 0;
        top: 0;
        background-size: cover;
        background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-disable.png");
        transform: rotate(180deg);
        width: 40px;
        height: 100px;
        z-index: 100;
      }
    }
  }
}
@media screen and (min-width: 751px) {
  .title {
    .pc-title {
      margin: 0 auto;
      display: block;
      width: 380px;
    }
    .m-title {
      display: none;
    }
  }
  .box {
    background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-box4.png");
    width: 1000px;
    height: 820px;
    .swiper-wrap {
      position: absolute;
      bottom: 3px;
      left: 3px;
      right: 3px;
      top: 3px;
      box-sizing: border-box;
      padding: 43px 40px 40px;
      border-radius: 40px;
      display: flex;
      flex-direction: column-reverse;
      .gallery-top {
        border: 4px solid #f5cd94;
        height: 600px;
        width: 900px;
      }
      .gallery-thumbs {
        box-sizing: border-box;
        width: 800px;
        margin: 0 57px;
        .swiper-slide {
          margin-bottom: 20px;
          box-sizing: border-box;
          height: 104px;
          width: 147px;
          border: 3px solid #af0404;
        }
        .swiper-slide-active {
          opacity: 1;
          border: 3px solid #f5cd94;
          &::before {
            content: "";
            width: 0;
            height: 0;
            position: absolute;
            bottom: -10px;
            top: inherit;
            left: calc(50% - 7px);
            border-top: solid 10px #f5cd94;
            border-right: solid 10px transparent;
            border-left: solid 10px transparent;
            border-bottom: none;
          }
        }
      }
      #enjoy-img-prev {
        position: absolute;
        left: 43px;
        top: 43px;
        cursor: pointer;
        margin-top: 20px;
        background-size: cover;
        background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-btn.png");
        width: 42px;
        height: 105px;
        z-index: 100;
        transform: rotateY(180deg);
        outline: none;
        &.swiper-button-disabled {
          position: absolute;
          right: 0;
          top: 0;
          background-size: cover;
          background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-disable.png");
          transform: rotateY(0);
          width: 40px;
          height: 100px;
          z-index: 100;
        }
      }
      #enjoy-img-next {
        position: absolute;
        right: 43px;
        top: 43px;
        cursor: pointer;
        margin-top: 20px;
        background-size: cover;
        background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-btn.png");
        width: 42px;
        height: 105px;
        z-index: 100;
        outline: none;
        &.swiper-button-disabled {
          position: absolute;
          right: 0;
          top: 0;
          background-size: cover;
          background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-disable.png");
          transform: rotate(180deg);
          width: 40px;
          height: 100px;
          z-index: 100;
        }
      }
    }
  }
}
</style>
